import React, { createContext, useState } from 'react'
import { Helmet } from 'react-helmet'
import Navbar8 from '../components/navbar8'
import Hero17 from '../components/hero17'
import ContentList4 from '../components/content-list4'
import Features24 from '../components/features24'
import Steps2 from '../components/steps2'
import Testimonial17 from '../components/testimonial17'
import Contact10 from '../components/contact10'
import Footer4 from '../components/footer4'
import './home.css' 


const Home = () => {
  const renderText = (text, className) => (
    <span className={className}>{text}</span>
  )

  return (
    <div className="home-container">
      <Helmet>
        <title>Commonwealth Artificial Intelligence Consortium</title>
        <meta property="og:title" content="Commonwealth Artificial Intelligence Consortium" />


 
      </Helmet>
      <Navbar8

      />
      <Hero17
        content1={renderText('Join us in shaping the future of Artificial Intelligence by collaborating with governments, industries, and academia to drive innovation, economic growth, and societal benefits.', 'home-text25 thq-body-large', { style: { textAlign: 'justify', display: 'block' } })}
        heading1={renderText('Empowering AI Innovation Across the Commonwealth', 'home-text26 thq-heading-1')}
        image1Src="/img-1500w.jpeg"
      />
      <ContentList4
        content1={
          <span className="home-text27 thq-body-small" style={{ textAlign: 'justify', display: 'block' }}>
            CAIC is committed to ensuring inclusive access for all, eliminating discrimination in cyberspace, and adopting online safety policies for all users, especially children, whilst upholding human rights.
          </span>
        }
        content2={
          <span className="home-text30 thq-body-small" style={{ textAlign: 'justify', display: 'block' }}>
            The CAIC's broad objective is to provide leadership, governance, advocacy and advisory services on the entire AI ecosystem for the Commonwealth Small States to adopt transformative and AI-driven technologies for the safe, inclusive and sustainable advancement of the members.
          </span>
        }
        content5={
          <span className="home-text31 thq-body-small" style={{ textAlign: 'justify', display: 'block' }}>
            The CAIC is governed by a Steering Committee chaired by Rwanda, with representation from the private sector, think tanks, and member states. Its work is carried out through four working groups: Research and Innovation, Capacity Building, Data & Infrastructure, and Policy Development.
          </span>
        }
        heading1={renderText('About the Commonwealth AI Consortium', 'home-text37 thq-heading-2')}
        heading2={renderText('The Plan', 'home-text38 thq-heading-3')}
        heading5={renderText('Governance of CAIC', 'home-text39 thq-heading-3')}
        heading6={renderText('Champion countries', 'home-text42 thq-heading-3')}
        heading7={renderText('Who We Are', 'home-text43 thq-heading-2')}
      />
      <h1>Our Working Groups</h1>
      <Features24
        feature1Title={renderText('Research & Innovation', 'home-text47 thq-heading-2')}
        feature2Title={renderText('Capacity Building', 'home-text48 thq-heading-2')}
        feature3Title={renderText('Data & Infrastructure', 'home-text49 thq-heading-2')}
        feature1Title1={renderText('Policy Development', 'home-text50 thq-heading-2')}
        feature1Description={
          <span className="home-text51 thq-body-small" style={{ textAlign: 'justify' }}>
            Empowering individuals and organizations with the knowledge and skills to harness the potential of AI.
          </span>
        }
        feature2Description={
          <span className="home-text52 thq-body-small" style={{ textAlign: 'justify' }}>
            Promoting ethical guidelines and best practices to ensure AI technologies are developed and used responsibly.
          </span>
        }
        feature3Description={
          <span className="home-text53 thq-body-small" style={{ textAlign: 'justify'}}>
            Advocating for the development of AI solutions that are accessible and beneficial to all members of society.
          </span>
        }
        feature1Description1={
          <span className="home-text54 thq-body-small" style={{ textAlign: 'justify' }}>
            Empowering individuals and organizations with the knowledge and skills to harness the potential of AI.
          </span>
        }
      />
      <Steps2
        step1Title={renderText('Commonwealth AI Academy', 'home-text55 thq-heading-2')}
        step2Title={renderText('AI Incubator', 'home-text56 thq-heading-2')}
        step3Title={renderText('Make-a-Thon', 'home-text57 thq-heading-2')}
        step4Title={renderText('Simplilearn', 'home-text58 thq-heading-2')}
        step1Description={
          <span className="home-text59 thq-body-small" style={{ textAlign: 'justify', display: 'block' }}>
            A collaboration with Intel on building the AI capacity for the Commonwealth members through skills and capacity building. The courses range from AI for the Public Sector to AI for Youths.
          </span>
        }
        step2Description={
          <span className="home-text62 thq-body-small" style={{ textAlign: 'justify', display: 'block' }}>
            Available for youth, including women who would like to benefit from learning- partnering with Universities and building solutions in SDG areas.
          </span>
        }
        step3Description={
          <span className="home-text63 thq-body-small" style={{ textAlign: 'justify', display: 'block' }}>
            Together Commonwealth and OpenWeaver aim to build the AI research, capacity and data, and infrastructure environment for the stakeholders in the Commonwealth.
          </span>
        }
        step4Description={
          <span className="home-text64 thq-body-small" style={{ textAlign: 'justify', display: 'block' }}>
            An industry-level certification from Simplilearn for free for countries and we can provide the offerings to your staff as well.
          </span>
        }
      />
      <Testimonial17/>
      <Contact10
        content1={renderText('For inquiries or partnership opportunities, please reach out to us using the contact information below.', 'home-text79 thq-body-large')}
        heading1={renderText('Contact Us', 'home-text80 thq-heading-2')}
        location1={renderText('London Office', 'home-text81 thq-heading-3')}
        location1Description={renderText('Marlborough House, Pall Mall, London - SW1', 'home-text82 thq-body-large')}
      />
      <Footer4

      />
    </div>
  )
}

export default Home
